function CartReload(data) {
  var container = document.getElementById('cart-table'),
      tT = document.getElementById('total-top'),
      c = document.querySelector('.cart-table'),
      tB = document.getElementById('total-bottom');
  const parser = new DOMParser();
  const htmlDocument = parser.parseFromString(data, 'text/html');
  var nTT = htmlDocument.documentElement.querySelector('#total-top'),
      nC = htmlDocument.documentElement.querySelector('.cart-table'),
      nTB = htmlDocument.documentElement.querySelector('#total-bottom');
  tT.replaceWith(nTT);
  c.replaceWith(nC);
  tB.replaceWith(nTB);  
  container.querySelector('.full-form').classList.remove('hidden');
  container.querySelector('.empty-form').classList.add('hidden');
  Quantity(container);
  CartButtons();
}

function CartChange(q,container) {
  var header = document.querySelector('header'),
      it = q.closest('.item'),
      id = it.getAttribute('data-product-id'),
      q =  it.querySelector('.item-qty').value,
      iQ = it.querySelector('.item-qty'),
      s = it.querySelector('.error'),
      aB = document.getElementById('ajaxBusy'),
      cTa = document.getElementById('cart-table'),
      cC = document.querySelectorAll('.cartCountSelector'),
      cT = document.querySelector('.cartTotalSelector'),
      tT = document.getElementById('total-cart-top'),
      c = document.querySelector('.cart-table'),
      tC = document.getElementById('cart-total'),
      tB = document.getElementById('total-cart-bottom'),
      dC = document.querySelector('.discount-cart'),
      aS = document.querySelector('.animate-section'),
      cD = document.getElementById('cart-dropdown');
  var minimum = parseInt(iQ.getAttribute('min'), 10) || 0,
      requested = parseInt(q, 10);
  if (q != '' && requested > 0 && minimum > 0 && requested < minimum) {
    q = String(minimum);
    iQ.value = q;
  }
  if (q != '') {
    aB.style.display = 'block';
  }
  fetch(theme.routes_cart_change_url + '.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({'quantity': q,'id':id})
  }).then(function(r) {
    return r.json();
  }).then(function(j) {
    if (q != '') {
      cC.forEach(function(c) {
        c.textContent = j.item_count;
      });
      if (header) {
        cT.innerHTML = Shopify.formatMoney(j.total_price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
        tT.innerHTML = Shopify.formatMoney(j.total_price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
      }
      if (j.cart_level_discount_applications && j.cart_level_discount_applications.length > 0) {
        tC.innerHTML = Shopify.formatMoney(j.items_subtotal_price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
        dC.innerHTML = Shopify.formatMoney('-' + j.total_discount, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
      }
      tB.innerHTML = Shopify.formatMoney(j.total_price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
    }    
    if (j.item_count == 0) {
      ShippingMsg();
      cTa.querySelector('.full-form').classList.add('hidden');
      cTa.querySelector('.empty-form').classList.remove('hidden');
      aB.style.display = 'none';
      if (theme.dropdown == true) {
        document.querySelector('.cart-count-mobile').setAttribute('href', theme.routes_cart_url);
        document.querySelector('.cart-count-mobile').classList.remove('void');
      }
      if (cD) {
        cD.remove();
      }
    } else {
      var x = theme.cart;
      CartDrop(x);
      document.dispatchEvent(new CustomEvent('cartItems', {
        bubbles: true
      }));
      fetch(theme.routes_cart_url)
      .then(response => response.text())
      .then(data => {
        if (q != '') {
          if (q == 0) {
            it.remove();
          }
          CartReload(data)
          aB.style.display = 'none';
        }        
      }).catch(function(err) {
        console.error('!: ' + err)
      });
    };
  }).catch(function(err) {
    console.error('!: ' + err)
  });
}

function CartButtons() {
  var container = document.getElementById('cart-table'),
      qB = container.querySelectorAll('.qtybtn');
  qB.forEach(function(q) {
    if (q.classList.contains('icon-plus')) {
      var qF = q.closest('.quantity.form'),
          vV = qF.querySelector('.item-qty').value,
          vM = qF.querySelector('.item-qty').getAttribute('max');
    };
    setTimeout(function () {
      q.onclick = function(ev){
        if (vM && vM == vV) {
          return;
        }
        CartChange(q,container);
      }
    }, 1);
  })  
  var qI = container.querySelectorAll('.item-qty');
  qI.forEach(function(q) {
    let timeout;
    var vV = q.value,
        vM = q.getAttribute('max');
    q.addEventListener('keyup', function (e) {
      if (e.key == 'Tab' || e.key == 'Shift') return;
      var nV = q.value;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        if (vM && nV == vV && vM == nV) {
          return;
        }
        CartChange(q,container);
      }, 750);
    });
  });  
}

theme.CartPage = (function() {
  function CartPage(container) {
    var sectionId = container.getAttribute('data-section-id'),
        chk = container.getAttribute('data-check'),
        acb = container.querySelector('.additional-checkout-buttons');
    theme.cart = true;
    Quantity(container);
    if(chk == 'true'){      
      var nC = container.querySelector('[name="checkout"]');
      document.getElementById('cart-terms').onclick = function(ev){
        if (this.checked == true) {
          nC.classList.remove('outline');
          nC.removeAttribute('disabled');
          nC.setAttribute('aria-label', theme.language.cart_general_checkout);
          nC.value = theme.language.cart_general_checkout;
          nC.textContent = theme.language.cart_general_checkout;
          if (acb) {
            acb.classList.remove('hidden');
          }
        } else {
          nC.classList.add('outline');
          nC.setAttribute('disabled', true);
          nC.setAttribute('aria-label', theme.language.cart_general_agree);
          nC.value = theme.language.cart_general_agree;
          nC.textContent = theme.language.cart_general_agree;
          if (acb) {
            acb.classList.add('hidden');
          }
        }
      };
    };
    CartButtons(container);
    if (Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  }
  return CartPage;
})();

(function () {
  'use strict';

  if (window.gmCartFulfillmentStatusInitialized) return;
  window.gmCartFulfillmentStatusInitialized = true;

  var PRODUCT_CONTEXT_CACHE = {};
  var SYNC_TIMER = null;
  var SYNC_RUNNING = false;

  function toInteger(value, fallback) {
    var parsed = Number(value);
    if (!Number.isFinite(parsed)) return fallback;
    return Math.max(0, Math.floor(parsed));
  }

  function cartRoot() {
    return document.getElementById('cart-table');
  }

  function localizedValue(attributeName) {
    var root = cartRoot();
    return root ? String(root.getAttribute(attributeName) || '') : '';
  }

  function quantityLabel(value) {
    var quantity = Math.max(0, toInteger(value, 0));
    return quantity.toLocaleString(document.documentElement.lang || undefined);
  }

  function localizedTemplate(attributeName, values) {
    var output = localizedValue(attributeName);
    Object.keys(values || {}).forEach(function (key) {
      output = output.split('__' + key.toUpperCase() + '__').join(String(values[key]));
    });
    return output;
  }

  function cartJsonUrl() {
    return localizedValue('data-gm-cart-json-url') || '/cart.js';
  }

  function productPageUrl(item) {
    var raw = String(item && (item.url || item.product_url) || '');
    if (!raw) return '';

    var url = new URL(raw, window.location.origin);
    var previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);
    return url.toString();
  }

  function fetchProductContext(item) {
    var url = productPageUrl(item);
    if (!url) return Promise.resolve(null);

    var cacheKey = String(item.variant_id || '') + '|' + url;
    if (PRODUCT_CONTEXT_CACHE[cacheKey]) return PRODUCT_CONTEXT_CACHE[cacheKey];

    PRODUCT_CONTEXT_CACHE[cacheKey] = fetch(url, {
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html' }
    }).then(function (response) {
      if (!response.ok) return null;
      return response.text();
    }).then(function (html) {
      if (!html) return null;

      var documentFragment = new DOMParser().parseFromString(html, 'text/html');
      var input = documentFragment.querySelector('[data-gm-mold-quantity]');
      if (!input) return null;

      var selector = input.closest('[data-gm-mold-selector]');
      return {
        available: input.getAttribute('data-gm-variant-available') === 'true',
        bulkSingleUnit: Boolean(selector && selector.getAttribute('data-gm-bulk-single-unit') === 'true'),
        inventory: toInteger(input.getAttribute('data-gm-available-inventory'), 0),
        kind: String(selector && selector.getAttribute('data-gm-product-kind') || 'gummy').toLowerCase(),
        minimum: toInteger(input.getAttribute('data-gm-minimum'), 10),
        policy: String(input.getAttribute('data-gm-inventory-policy') || '').toLowerCase(),
        readyStock: Boolean(selector && selector.getAttribute('data-gm-ready-stock') === 'true'),
        tracked: input.getAttribute('data-gm-inventory-tracked') === 'true'
      };
    }).catch(function () {
      return null;
    });

    return PRODUCT_CONTEXT_CACHE[cacheKey];
  }

  function statusForItem(item, context) {
    if (!context) return null;

    var requested = Math.max(0, toInteger(item && item.quantity, 0)),
        chocolate = context.kind === 'chocolate';

    if (context.readyStock) {
      if (context.tracked && context.policy === 'continue') {
        if (context.inventory <= 0) {
          return {
            kind: 'made',
            title: localizedValue('data-gm-made-title'),
            copy: chocolate
              ? localizedTemplate('data-gm-chocolate-sold-out-copy', { minimum: context.minimum }) || localizedValue('data-gm-sold-out-copy')
              : localizedValue('data-gm-sold-out-copy')
          };
        }

        if (requested > context.inventory) {
          return {
            kind: 'partial',
            title: localizedValue('data-gm-partial-title'),
            copy: chocolate
              ? localizedTemplate('data-gm-chocolate-partial-copy', { in_stock: quantityLabel(context.inventory), remaining: quantityLabel(requested - context.inventory) }) || localizedTemplate('data-gm-partial-copy', { in_stock: quantityLabel(context.inventory), remaining: quantityLabel(requested - context.inventory) })
              : localizedTemplate('data-gm-partial-copy', { in_stock: quantityLabel(context.inventory), remaining: quantityLabel(requested - context.inventory) })
          };
        }
      }

      if (context.available) {
        return {
          kind: 'ready',
          title: localizedValue('data-gm-in-stock-title'),
          copy: chocolate
            ? localizedValue('data-gm-chocolate-in-stock-copy') || localizedValue('data-gm-in-stock-copy')
            : localizedValue('data-gm-in-stock-copy')
        };
      }
    }

    if (context.bulkSingleUnit) {
      return {
        kind: 'made',
        title: localizedValue('data-gm-made-title'),
        copy: chocolate
          ? localizedTemplate('data-gm-chocolate-bulk-copy', { minimum: context.minimum }) || localizedValue('data-gm-bulk-copy')
          : localizedValue('data-gm-bulk-copy')
      };
    }

    return null;
  }

  function renderStatus(item, status) {
    if (!item) return;

    var row = document.getElementById('product-id-' + String(item.key));
    if (!row) return;

    var statusElement = row.querySelector('.gm-cart-item-status');
    if (!status) {
      if (statusElement) statusElement.remove();
      return;
    }

    var details = row.querySelector('.item-details > div:first-child') || row.querySelector('.item-details');
    if (!details) return;

    var signature = [status.kind, status.title, status.copy].join('|');
    if (statusElement && statusElement.getAttribute('data-gm-status-signature') === signature) return;

    if (!statusElement) {
      statusElement = document.createElement('p');
      details.appendChild(statusElement);
    }

    statusElement.className = 'gm-cart-item-status gm-cart-item-status--' + status.kind;
    statusElement.setAttribute('data-gm-status-signature', signature);
    statusElement.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm4.6 7.2-5.3 6.2a1 1 0 0 1-1.5.1l-2.5-2.4a1 1 0 1 1 1.4-1.4l1.7 1.6 4.7-5.4a1 1 0 1 1 1.5 1.3Z"/></svg><span><strong></strong><span></span></span>';
    statusElement.querySelector('strong').textContent = status.title;
    statusElement.querySelector('span > span').textContent = status.copy;
  }

  function updateAssurance(statuses) {
    var hasPartial = statuses.some(function (status) {
      return status && status.kind === 'partial';
    });

    if (!hasPartial) return;

    var assuranceCopy = document.querySelector('.gm-cart-assurance li:first-child span:last-child');
    var partialCopy = localizedValue('data-gm-partial-assurance');
    if (assuranceCopy && assuranceCopy.textContent !== partialCopy) {
      assuranceCopy.textContent = partialCopy;
    }
  }

  function synchronizeCartStatuses() {
    if (SYNC_RUNNING || !document.querySelector('#cart-table .cart-table')) return;
    SYNC_RUNNING = true;

    fetch(cartJsonUrl(), {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to read cart fulfillment status.');
      return response.json();
    }).then(function (cart) {
      return Promise.all((cart.items || []).map(function (item) {
        return fetchProductContext(item).then(function (context) {
          var status = statusForItem(item, context);
          renderStatus(item, status);
          return status;
        });
      }));
    }).then(updateAssurance).catch(function () {
      return null;
    }).finally(function () {
      SYNC_RUNNING = false;
    });
  }

  function scheduleSync(delay) {
    window.clearTimeout(SYNC_TIMER);
    SYNC_TIMER = window.setTimeout(synchronizeCartStatuses, delay || 0);
  }

  function mutationIsManagedStatusUi(mutation) {
    var target = mutation.target;
    var targetElement = target && target.nodeType === 1 ? target : target && target.parentElement;
    if (targetElement && targetElement.closest && targetElement.closest('.gm-cart-item-status, .gm-cart-assurance')) {
      return true;
    }

    var changedNodes = Array.prototype.slice.call(mutation.addedNodes || []).concat(Array.prototype.slice.call(mutation.removedNodes || []));
    if (!changedNodes.length) return false;

    return changedNodes.every(function (node) {
      if (!node || node.nodeType !== 1) return false;
      return node.matches('.gm-cart-item-status, .gm-cart-assurance') || Boolean(node.closest && node.closest('.gm-cart-item-status, .gm-cart-assurance'));
    });
  }

  function initializeObserver() {
    var cartTable = document.getElementById('cart-table');
    if (!cartTable || !window.MutationObserver) return;

    var observer = new MutationObserver(function (mutations) {
      var shouldSync = mutations.some(function (mutation) {
        return !mutationIsManagedStatusUi(mutation);
      });
      if (shouldSync) scheduleSync(75);
    });

    observer.observe(cartTable, {
      childList: true,
      subtree: true
    });
  }

  function initialize() {
    scheduleSync(0);
    initializeObserver();
    document.addEventListener('cartItems', function () {
      scheduleSync(150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
